import { apiCall } from "api/axios";
import { IExportResponseData } from "api/business-user-management/types";
import { formatObjectToQueryString, getTodayAsEndDateFilterValue } from "utils";

import {
  IExportBusinessTransactionsPayload,
  IGetBusinessBillPaymentsTransactionsPayload,
  IGetBusinessBillPaymentsTransactionsResult,
  IGetBusinessTransactionDetailsPayload,
  IGetBusinessTransactionDetailsResult,
  IGetBusinessTransactionStatusPayload,
  IGetBusinessTransactionStatusResult,
  IGetBusinessTransactionsAnalyticsPayload,
  IGetBusinessTransactionsAnalyticsResult,
  IGetBusinessTransactionsStatsPayload,
  IGetBusinessTransactionsStatsResult,
  IGetBusinessTransfersTransactionsPayload,
  IGetBusinessTransfersTransactionsResult,
  IReverseTransactionPayload,
  IReverseTransactionResult,
} from "./types";

export const getBusinessTransactionsStats = async (
  payload: IGetBusinessTransactionsStatsPayload
) => {
  const queryString = formatObjectToQueryString(
    payload as unknown as Record<string, string>
  );
  const result = await apiCall({
    apiRoute: `/control/transactions/business/stat?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IGetBusinessTransactionsStatsResult;
};

export const getBusinessTransactionsAnalytics = async (
  payload: IGetBusinessTransactionsAnalyticsPayload
) => {
  const queryString = formatObjectToQueryString(
    payload as unknown as Record<string, string>
  );
  const result = await apiCall({
    apiRoute: `/control/transactions/business/analysis?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IGetBusinessTransactionsAnalyticsResult;
};

export const exportBusinessTransactionsData = async (
  payload: IExportBusinessTransactionsPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/transactions/business/export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const getBusinessTransfersTransactions = async (
  payload: IGetBusinessTransfersTransactionsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/transactions/business/transfer?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  //   console.log({ result });
  return result as IGetBusinessTransfersTransactionsResult;
};

export const getBusinessBillPaymentsTransactions = async (
  payload: IGetBusinessBillPaymentsTransactionsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/transactions/business/bill-payment?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  //   console.log({ result });
  return result as IGetBusinessBillPaymentsTransactionsResult;
};

export const getBusinessTransactionStatus = async (
  payload: IGetBusinessTransactionStatusPayload
) => {
  const result = await apiCall({
    apiRoute: "/accounts/transactions/transaction-status",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGetBusinessTransactionStatusResult;
};

export const markBusinessTransactionAsSuccessful = async (
  payload: IGetBusinessTransactionStatusPayload
) => {
  const result = await apiCall({
    apiRoute: "/accounts/transactions/update-transaction-status-to-successul",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGetBusinessTransactionStatusResult;
};

export const getBusinessTransactionDetails = async (
  payload: IGetBusinessTransactionDetailsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/transactions/transaction-detail",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGetBusinessTransactionDetailsResult;
};

export const reverseTransferTransaction = async (
  payload: IReverseTransactionPayload
) => {
  const result = await apiCall({
    apiRoute: "/accounts/transactions/reverse-funds-transfer",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IReverseTransactionResult;
};

export const reverseBillPaymentTransaction = async (
  payload: IReverseTransactionPayload
) => {
  const result = await apiCall({
    apiRoute: "/pay-bills/reverse-bill-payment-transaction",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IReverseTransactionResult;
};
